export class Transaction {
  public pvTransactions: any
  public transactionId: number

  constructor() {
    this.pvTransactions = {}
    this.transactionId = 0
  }

  public create() {
    return ++this.transactionId
  }

  public current() {
    return this.transactionId
  }

  public get(tId: number) {
    return this.pvTransactions[tId]
  }

  public set(tId: number, value: any) {
    this.pvTransactions[tId] = value
  }

  public remove(tId: number) {
    if (tId && this.pvTransactions[tId]) {
      delete this.pvTransactions[tId]
    }
  }

  public keys() {
    return Object.keys(this.pvTransactions)
  }
}
